<div class="login-card">
    <div class="logo">
        <h1>WATCHZAAR</h1>
    </div>
    <div class="login-welcome">
        <h2>WELCOME BACK</h2>
        <p>Log in to your account</p>
    </div>
    <form [formGroup]="loginForm">
        <div class="form-group">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Email</mat-label>
                <input matInput formControlName="email" type="text" id="email" name="email" required />
                <mat-error *ngIf="loginForm.get('email')?.invalid && loginForm.get('email')?.touched">
                    <span *ngIf="loginForm.get('email')?.errors?.['required']">This field is required.</span>
                    <span *ngIf="loginForm.get('email')?.errors?.['email']">Please enter a valid email address.</span>
                </mat-error>
            </mat-form-field>
        </div>
        <div class="form-group">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Password</mat-label>
                <input matInput formControlName="password" type="password" id="password" name="password" required />
                <mat-error *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
                    <span *ngIf="loginForm.get('password')?.errors?.['required']">This field is required.</span>
                </mat-error>
            </mat-form-field>
        </div>
        <div class="form-group">
            <div class="remember-reset">
                <mat-checkbox class="remember-me-checkbox">Remember Me</mat-checkbox>
                <a href="/reset-password" class="reset-link">Forgot Password?</a>
            </div>
        </div>
        <div class="form-group signin-button">
            <button
                mat-stroked-button
                color="primary"
                type="submit"
                class="full-width"
                [disabled]="loginForm.invalid"
                (click)="login()"
            >
                Sign In
            </button>
        </div>
    </form>
    <div class="alternative-login">
        <div class="divider-container">
            <hr class="divider" />
            <p class="divider-text">Or</p>
            <hr class="divider" />
        </div>

        <div class="form-group signin-button">
            <div class="app-apple-sign-container">
                <app-apple-signin></app-apple-signin>
            </div>
        </div>
        <div class="form-group signin-button">
            <div class="app-google-sign-container">
                <app-google-signin></app-google-signin>
            </div>
        </div>
    </div>

    <div class="create-account">
        <p>New User? <a class="register-link" href="/auth/register"> SIGN UP HERE</a></p>
    </div>
</div>
